import { useUser } from '~/@biz_account/useUser/useUser'
import { useCompanyInfo } from '~/@mid_settings/company-info/useCompanyInfo'

function useWithdrawFundsInfo() {
  const companyInfo = useCompanyInfo()
  const { user } = useUser()
  const bankAccounts = user?.profile?.bankAccounts

  return {
    bankAccountIbans: bankAccounts?.map(({ iban }) => iban),
    walletFunds: user?.investorWallet?.aggregates,
    companyIban: companyInfo?.iban,
  }
}

export { useWithdrawFundsInfo }
